import { render, staticRenderFns } from "./CarreraDuplicarForm.vue?vue&type=template&id=396d6ca4"
import script from "./CarreraDuplicarForm.vue?vue&type=script&lang=js"
export * from "./CarreraDuplicarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports